module.exports = __webpack_public_path__ + "static/homepage-hero-tvc-landscape-2400w-9066b2dfd4d1c2b110bece92534abf24.jpg";